import Controller from './stepMiniPedagogicalApproachController';

const stepMiniPedagogicalApproachComponent = {
    template: require('./stepMiniPedagogicalApproachView.html'),
    controller: Controller,
};

export default stepMiniPedagogicalApproachComponent;


// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepMiniPedagogicalApproach/stepMiniPedagogicalApproachComponent.js